import React, { useEffect, useState } from 'react'
import { Assessment, assessmentDefsHooks } from 'pages/AssessmentDefs'
import { WrapAssessmentDefsItems, WrapHeaderActions, } from './Style'
import { fieldsTyps, Input } from 'components/Form'
import { searchByKeys } from 'utils/array'
import { WrapAll, WrapHeader } from 'styles/GlobalStyle'
import { isEmpty } from 'lodash'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getAssessmentDefsFetch } from 'store/middlewares/assessment.crud'
import { assessmentsHooks } from '../School/Assessments'
import { WrapDataGrid } from 'components/DataGrid/Style'
import AssessmentFiltersHeader from 'pages/School/Assessments/AssessmentFiltersHeader'

const AssessmentDefs = (props) => {
    const { assessments, assessmentFilters: pAssessmentFilters, setAssessmentFilters: pSetAssessmentFilters } = props
    const [filterAssessments, setFilterAssessments] = useState(assessments?.data)
    const [assessmentFilters, setAssessmentFilters] = useState({
        category: null
    })

    const headerItems = assessmentsHooks.useHeaderItems()

    const assessmentDefOptions = useQuery({
        queryKey: [qc.allAssessmentDefs],
        refetchOnWindowFocus: false,
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentDefsFetch({ assessmentFilters: pAssessmentFilters || assessmentFilters })
            setFilterAssessments(data)
            return data
        },
        enabled: !assessments
    })

    const [searchVal, setSearchVal] = useState('')

    const headerActions = assessmentDefsHooks.useHeaderActions()
    const { search, assessmentKeysForSearch } = assessmentDefsHooks.constants

    // const currentAssessments = assessments || assessmentDefOptions.data || []

    useEffect(() => {
        if (assessments?.data)
            setFilterAssessments(assessments?.data)
    }, [assessments?.data])

    const searchAssessmentDefs = (val) => {
        setSearchVal(val)
        const nAssessmentDefs = searchByKeys(assessments?.data || assessmentDefOptions.data, val, assessmentKeysForSearch)
        setFilterAssessments(nAssessmentDefs)
    }

    return (
        <WrapDataGrid overflow>
            <AssessmentFiltersHeader
                refetchData={assessments?.refetch || assessmentDefOptions?.refetch}
                headerItems={[{ ...headerItems.category, multiple: false }]}
                assessmentFilters={pAssessmentFilters}
                setAssessmentFilters={pSetAssessmentFilters || setAssessmentFilters}
            />
            <WrapAll>
                <WrapHeader>
                    <WrapHeaderActions>
                        <Input {...search}
                            input={{
                                value: searchVal,
                                onChange: searchAssessmentDefs
                            }} />
                        {headerActions.map((act, index) => {
                            const Component = fieldsTyps[act.component]
                            return (
                                <Component key={index} {...act} />)
                        })}
                    </WrapHeaderActions>
                </WrapHeader>

                <WrapAssessmentDefsItems>
                    {isEmpty(filterAssessments) || filterAssessments?.map((assessment) =>
                        <Assessment
                            student={true}
                            key={assessment.id}
                            {...props}
                            {...assessment} />
                    )}
                </WrapAssessmentDefsItems>
            </WrapAll>
        </WrapDataGrid>
    )
}

export default AssessmentDefs